<template>
  <section>
    <!-- <b-container fluid class="datas"> -->
    <b-container fluid class="datas" :style="datas_bg">
      <b-row class="justify-content-center p_r">
        <!--  -->
        <b-col
          cols="11"
          sm="10"
          md="9"
          xl="8"
          class="flex-column justify-content-center d-flex datas_box"
        >
          <div class="jian">
            <v-com_title :msg="hTitle[0]"></v-com_title>
          </div>
        </b-col>
        <b-col
          md="12"
          class="text-center flex-column justify-content-center d-flex"
          :style="datas_box_c"
          >
          <!-- style="background: rgba(255, 255, 255, 0.1)" -->
          <b-container fluid class="d-none d-md-block">
            <b-row class="justify-content-start">
              <b-col
                md="3"
                class="d-flex flex-column align-items-center justify-content-center left_box1"
                >
                <!-- style="background-color: #ffc" -->
                <div class="left_box" :style="left_box">
                  <span
                    class="text_s"
                    v-for="(item, index) in dataList1"
                    :key="index"
                    >{{ item }}</span
                  >
                  <!-- <span class="text_s" v-for="(item,index) in 11 " :key="index">{{item}}</span> -->
                </div>
                <span class="bg_s" v-for="(val, i) in 4" :key="i"></span>
              </b-col>
              <b-col cols="6" class="justify-content-center d-flex">
                <!-- style="background-color: #fcc" -->
                <b-container fluid>
                  <b-row class="justify-content-start">
                    <b-col
                      cols="3"
                      class="justify-content-center d-flex left_per"
                    >
                      <!-- style="height: 100px; background: #ff0" -->
                      <div>
                        <div class="left_z" :style="left_z">运输周转量</div>
                        <div class="left_num" :style="lor_num">
                          1223<span>↓</span>
                        </div>
                        <div class="left_tip" :style="left_tip">较上月</div>
                        <div class="left_max" :style="left_max">
                          本月最大涨幅
                        </div>
                      </div>
                    </b-col>
                    <b-col
                      cols="6"
                      class="justify-content-center d-flex center_box"
                    >
                      <div>
                        <div class="center_num" :style="center_num">86.4</div>
                        <div class="left_tip" :style="left_tip">
                          飞机日利用率
                        </div>
                        <div class="center_max" :style="center_max">
                          <span :style="center_max_span">2.8%↑ </span> 较上月
                        </div>
                      </div>
                    </b-col>
                    <b-col
                      cols="3"
                      class="justify-content-center d-flex right_per"
                    >
                      <div>
                        <div class="left_z" :style="left_z">旅客吞吐量</div>
                        <div class="right_num" :style="lor_num">
                          890<span>↑</span>
                        </div>
                        <div class="left_tip" :style="left_tip">较上月</div>
                        <div class="left_max" :style="left_max">
                          本月最大涨幅
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
              <b-col
                md="3"
                class="d-flex flex-column align-items-center justify-content-center right_box1"
              >
                <!-- style="background-color: #fcf;" -->
                <div class="right_box" :style="left_box">
                  <!-- <span class="text_s" v-for="(item,index) in 11 " :key="index">{{item}}</span> -->

                  <span
                    class="text_s"
                    v-for="(item, index) in dataList2"
                    :key="index"
                    >{{ item }}</span
                  >
                </div>
                <span class="bg_s" v-for="(val, i) in 4" :key="i"></span>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid class="d-block d-md-none">
            <b-row class="justify-content-center">
              <b-col cols="11" class="justify-content-center d-flex"    >
                <!-- style="background-color: #fcc;" -->
             

                <b-container fluid>
                  <b-row class="justify-content-start">
                    <b-col
                      cols="3"
                      class="justify-content-center d-flex left_per"
                      >
                      <!-- style="height: 100px; background: #ff0" -->
                      <div>
                        <div class="left_z" :style="left_z">运输周转量</div>
                        <div class="left_num" :style="lor_num">
                          1223<span>↓</span>
                        </div>
                        <div class="left_tip" :style="left_tip">较上月</div>
                        <div class="left_max" :style="left_max">
                          本月最大涨幅
                        </div>
                      </div>
                    </b-col>
                    <b-col
                      cols="6"
                      class="justify-content-center d-flex center_box"
                    >
                      <div>
                        <div class="center_num" :style="center_num">86.4</div>
                        <div class="left_tip" :style="left_tip">
                          飞机日利用率
                        </div>
                        <div class="center_max" :style="center_max">
                          <span :style="center_max_span">2.8%↑ </span> 较上月
                        </div>
                      </div>
                    </b-col>
                    <b-col
                      cols="3"
                      class="justify-content-center d-flex right_per"
                    >
                      <div>
                        <div class="left_z" :style="left_z">旅客吞吐量</div>
                        <div class="right_num" :style="lor_num">
                          890<span>↑</span>
                        </div>
                        <div class="left_tip" :style="left_tip">较上月</div>
                        <div class="left_max" :style="left_max">
                          本月最大涨幅
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>

              <b-col
                cols="11"
                md="4"
                class="d-flex flex-column align-items-start justify-content-start left_box1"
                >
                <!-- style="background-color: rgb(210, 255, 204);" -->
                <div class="left_box" :style="left_box" >
                  <!-- style="background-color: #ccc;" -->
                  <span
                    class="text_s"
                    v-for="(item, index) in dataList3"
                    :key="index"
                    >{{ item }}</span
                  >
                  <!-- <span class="text_s" v-for="(item,index) in 22 " :key="index">{{item}}</span> -->
                </div>
                <span class="bg_s" v-for="(val, i) in 4" :key="i"></span>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
// import qs from "qs";
import Com_title from "../com-title";
export default {
  components: {
    "v-com_title": Com_title,
  },
  data() {
    return {
      hTitle: ["民航大数据"],
      keywords: [],
      datas_bg: {
        height: 800,
      },
      left_box: {
        height: 500,
      },
      datas_box_c: {
        position: "absolute",
        top: 150,
      },
      center_num: {
        fontSize: 90,
        lineHeight: 110,
      },
      lor_num: {
        fontSize: 28,
        lineHeight: 60,
      },
      left_z: {
        fontSize: 24,
        lineHeight: 48,
      },
      left_max: {
        fontSize: 18,
        lineHeight: 70,
      },
      center_max: {
        fontSize: 15,
        lineHeight: 80,
      },
      center_max_span: {
        fontSize: 40,
        marginLeft: 40,
      },
      left_tip: {
        fontSize: 16,
      },
      screenWidth: 0,
      dataList1: [],
      dataList2: [],
      dataList3: [],
      timer: null,
    };
  },
  created() {
  },
  mounted() {
    this.getData();
    // 首次加载时,需要调用一次
    let _this = this;
    this.timer = setInterval(() => {
      _this.getData();
    }, 1000 * 2);
    _this.screenWidth = window.innerWidth;
    _this.setReSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      _this.screenWidth = window.innerWidth;
      _this.setReSize();
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getData(arr) {
     
      this.dataList3 = [
        "运输航空",
        "通用航空",
        "智慧",
        "绿色",
        "人文",
        "高效",
        "数据",
        "安全",
        "航空",
        "物流",
        "机场网",
        "无人机",
        "适航",
        "飞行员",
        "航空器",
        "航班",
        "旅客",
        "空域",
        "客舱",
        "签派",
        "维修",
        "监管",
      ];
      this.dataList1 = this.dataList3.slice(0,11)
      this.dataList2 = this.dataList3.slice(11,22)
      this.sort(this.dataList1);
      this.sort(this.dataList2);
      this.sort(this.dataList3);
    },
    sort(arr) {
      arr.sort(function () {
        return Math.random() - 0.5;
      });
    },
    setReSize() {
      let _this = this;
      if (_this.screenWidth < 321) {
        _this.left_box.top = ((70 * 4) / 1920) * _this.screenWidth + "px";
      } 
      if (_this.screenWidth > 322 && _this.screenWidth < 575) {
        _this.left_box.top = ((70 * 9.8) / 1920) * _this.screenWidth + "px";
      } 
      else if (_this.screenWidth > 576 && _this.screenWidth < 767) {
        _this.left_box.top = ((70 * 11) / 1920) * _this.screenWidth + "px";
      }
      if (_this.screenWidth > 767) {
        // if (_this.screenWidth > 576) {
        _this.datas_bg = {
          height: (800 / 1920) * _this.screenWidth + "px",
        };
        _this.left_box = {
          height: (500 / 1920) * _this.screenWidth + "px",
        };
        _this.datas_box_c.top = (150 / 1920) * _this.screenWidth + "px";
        _this.left_tip.fontSize = (16 / 1920) * _this.screenWidth + "px";
        _this.center_num = {
          fontSize: (90 / 1920) * _this.screenWidth + "px",
          lineHeight: (110 / 1920) * _this.screenWidth + "px",
        };
        _this.lor_num = {
          fontSize: (28 / 1920) * _this.screenWidth + "px",
          lineHeight: (60 / 1920) * _this.screenWidth + "px",
        };
        _this.left_z = {
          fontSize: (24 / 1920) * _this.screenWidth + "px",
          lineHeight: (48 / 1920) * _this.screenWidth + "px",
        };
        _this.left_max = {
          fontSize: (18 / 1920) * _this.screenWidth + "px",
          lineHeight: (70 / 1920) * _this.screenWidth + "px",
        };
        _this.center_max = {
          fontSize: (15 / 1920) * _this.screenWidth + "px",
          lineHeight: (80 / 1920) * _this.screenWidth + "px",
        };

        _this.center_max_span = {
          fontSize: (40 / 1920) * _this.screenWidth + "px",
          marginLeft: -(40 / 1920) * _this.screenWidth + "px",
        };
      } else {
        _this.datas_bg = {
          height: ((800 * 4) / 1920) * _this.screenWidth + "px",

          backgroundSize: "100% 100%",
          backgroundPosition: "center center",
        };
        _this.left_box.height = ((500 * 2.5) / 1920) * _this.screenWidth + "px";
        _this.datas_box_c.top = ((150 * 3.5) / 1920) * _this.screenWidth + "px";
        _this.left_tip.fontSize = ((16 * 2) / 1920) * _this.screenWidth + "px";
        _this.center_num = {
          fontSize: ((90 * 1.5) / 1920) * _this.screenWidth + "px",
          lineHeight: ((110 * 2) / 1920) * _this.screenWidth + "px",
        };
        _this.lor_num = {
          fontSize: ((28 * 2.5) / 1920) * _this.screenWidth + "px",
          lineHeight: ((60 * 2.5) / 1920) * _this.screenWidth + "px",
        };
        _this.left_z = {
          fontSize: ((24 * 2.5) / 1920) * _this.screenWidth + "px",
          lineHeight: ((48 * 2) / 1920) * _this.screenWidth + "px",
        };
        _this.left_max = {
          fontSize: ((18 * 2) / 1920) * _this.screenWidth + "px",
          lineHeight: ((70 * 3) / 1920) * _this.screenWidth + "px",
        };
        _this.center_max = {
          fontSize: ((15 * 2) / 1920) * _this.screenWidth + "px",
          lineHeight: ((80 * 2.4) / 1920) * _this.screenWidth + "px",
        };

        _this.center_max_span = {
          fontSize: ((40 * 2) / 1920) * _this.screenWidth + "px",
          marginLeft: -((40 * 2) / 1920) * _this.screenWidth + "px",
        };
      }
    },
  },
};
</script>

<style>
@import "../../../assets/css/datas.css";
</style>
<style lang="less" scoped>
/* #hotKey {
      height: 40%;
    } */
.datas_box {
  margin-top: 10px;
}
/deep/.title-h1-box {
  position: relative;
  background-image: url("../../../assets/images/index/bg_plane.png"),
    url("../../../assets/images/index/bg_plane2.png");
  background-repeat: no-repeat, no-repeat;
  background-position: left 55px top 35px, left 225px top 35px;
  background-size: 173px 15px, 105px 16px;
  margin: 10px 0;
}

/deep/ .title-h1-box h1 {
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 575px) {
  /* .datas_box{
      margin-top: 0px ;
    } */
  .datas {
    background: url(../../../assets/images/data_bg_m_1.png) no-repeat;
    /* background: url(../../../assets/images/gly.jpg) no-repeat; */
  }
  /deep/.title-h1-box {
    background-repeat: no-repeat, no-repeat;
    background-position: left 30px top 17px, left 155px top 17px;
    background-size: 130px 13px, 75px 13px;
  }
  .left_box {
    padding-top: 10px;
  }
  /deep/.left_box .text_s,
  /deep/.right_box .text_s,
  /deep/.left_box1 .bg_s,
  /deep/.right_box1 .bg_s {
    transform: scale(0.55, 0.55);
  }
  .left_per {
        padding-right: 3%;
    }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .datas {
    background: url(../../../assets/images/data_bg_m_1.png) no-repeat;
    /* background: url(../../../assets/images/gly.jpg) no-repeat; */
  }
  /deep/.title-h1-box {
    background-repeat: no-repeat, no-repeat;
    background-position: left 30px top 20px, left 190px top 20px;
    background-size: 165px 15px, 90px 15px;
  }
  /deep/.left_box .text_s,
  /deep/.right_box .text_s,
  /deep/.left_box1 .bg_s,
  /deep/.right_box1 .bg_s {
    transform: scale(0.9, 0.9);
  }
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  /* .datas {
    transform: scale(1,.8);
  } */
  /deep/.title-h1-box {
    background-repeat: no-repeat, no-repeat;
    background-position: left 45px top 24px, left 205px top 24px;
    background-size: 160px 15px, 100px 15px;
  }
  /deep/.left_box .text_s,
  /deep/.right_box .text_s,
  /deep/.left_box1 .bg_s,
  /deep/.right_box1 .bg_s {
    transform: scale(0.6, 0.6);
  }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  /* .datas {
    transform: scale(1,.9);
  } */
  /deep/.title-h1-box {
    background-repeat: no-repeat, no-repeat;
    background-position: left 45px top 24px, left 205px top 24px;
    background-size: 160px 15px, 100px 15px;
  }
  /deep/.left_box .text_s,
  /deep/.right_box .text_s,
  /deep/.left_box1 .bg_s,
  /deep/.right_box1 .bg_s {
    transform: scale(0.65, 0.65);
  }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) and (max-width: 1440px) {
  /deep/.left_box .text_s,
  /deep/.right_box .text_s,
  /deep/.left_box1 .bg_s,
  /deep/.right_box1 .bg_s {
    transform: scale(0.7, 0.7);
  }
}
@media (min-width: 1441px) and (max-width: 1680px) {
  /deep/.left_box .text_s,
  /deep/.right_box .text_s,
  /deep/.left_box1 .bg_s,
  /deep/.right_box1 .bg_s {
    transform: scale(0.85, 0.85);
  }
}
@media (min-width: 1681px) {
}
</style>
